import { Grid, Button, Divider } from '@mui/material';

import { TableTopBar } from 'components/table/table-top-bar';

import { useQueries } from 'hooks/useQueries/useQueries';

import { tableTopBarStyles } from 'components/table/table-top-bar/styles';
import { selectPopoverStyles } from 'components/popovers/select-popover/styles';

interface IProps {
  onAddPlan: () => void;
}

export const PlanTableTopBar = ({ onAddPlan }: IProps) => {
  const { setQueries, parsedQueries } = useQueries();

  const defaultValues: { search: string } = {
    search: (parsedQueries.search as string) || '',
  };

  const updateQueries = (formData: { search?: string }, page = '1') => {
    setQueries({ page, ...formData });
  };

  const getDebouncedSearch = (value: string) => updateQueries({ search: value });

  return (
    <Grid sx={tableTopBarStyles.container}>
      <TableTopBar defaultValues={defaultValues as any} getDebouncedSearch={getDebouncedSearch} />
      <Divider sx={tableTopBarStyles.divider} />
      <Button sx={selectPopoverStyles.button} onClick={onAddPlan}>
        Add new
      </Button>
    </Grid>
  );
};
